import { render, staticRenderFns } from "./areaCourseShow.vue?vue&type=template&id=6781addb&"
import script from "./areaCourseShow.vue?vue&type=script&lang=js&"
export * from "./areaCourseShow.vue?vue&type=script&lang=js&"
import style0 from "./areaCourseShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports